// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2aIE1","header":"PatientBlock_header__3rP33","label":"PatientBlock_label__3Cipv","option":"PatientBlock_option__IJ_H9"};